import { gql, useMutation, useQuery } from 'urql';

export const CHECK_CATEGORY_NAME_QUERY = gql`
  query CheckCategory($title: String!, $eventId: Int!) {
    checkCategory(input: { title: $title, eventId: $eventId }) {
      exist
    }
  }
`;

export const CREATE_CATEGORY_MUTATION = gql`
  mutation CreateCategory($title: String!, $eventId: Int!, $description: String, $color: ColorEnum) {
    createCategory(input: { title: $title, eventId: $eventId, description: $description, color: $color }) {
      id
      title
      description
      eventId
      color
    }
  }
`;

interface CheckCategoryNameResponse {
  checkCategory: {
    exist: boolean;
  };
}

interface CheckCategoryNameVariables {
  title: string;
  eventId: number;
}

export const useCheckCategoryName = ({ title, eventId, pause }: CheckCategoryNameVariables & { pause?: boolean }) => {
  return useQuery<CheckCategoryNameResponse, CheckCategoryNameVariables>({
    query: CHECK_CATEGORY_NAME_QUERY,
    variables: {
      title,
      eventId,
    },
    pause,
    requestPolicy: 'network-only',
  });
};

interface CreateCategoryResponse {
  createCategory: {
    id: number;
    title: string;
    description: string;
    color: string;
    eventId: number;
  };
}

interface CreateCategoryVariables {
  title: string;
  eventId: number;
  description: string;
  color?: string;
}

export const useCreateCategory = () => {
  return useMutation<CreateCategoryResponse, CreateCategoryVariables>(CREATE_CATEGORY_MUTATION);
};
